const toDate = (value) => {
  const parsed = new Date(value || "");
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const notificationKindToPreferenceKeys = {
  leaves: ["leave_approved_in_app", "leave_rejected_in_app", "team_member_on_leave_in_app", "birthday_reminder_in_app"],
  tasks: ["task_assigned_in_app", "task_overdue_in_app", "task_completed_in_app", "mention_in_app"],
  projects: ["project_added_in_app", "project_health_drops_in_app", "weekly_digest_in_app"],
  learning: ["course_assigned_in_app", "course_deadline_in_app", "proof_verified_in_app"],
  members: ["new_member_in_app"],
  roles: ["mention_in_app"],
};

export const notificationTabs = [
  { id: "all", label: "All" },
  { id: "leaves", label: "Leaves" },
  { id: "tasks", label: "Tasks" },
  { id: "projects", label: "Projects" },
  { id: "learning", label: "Learning" },
  { id: "members", label: "Members" },
  { id: "roles", label: "Roles" },
];

export const notificationSectionLabel = {
  today: "Today",
  yesterday: "Yesterday",
  this_week: "This week",
  earlier: "Earlier",
};

export const notificationKindLabel = {
  leaves: "Leave",
  tasks: "Task",
  projects: "Project",
  learning: "Learning",
  members: "Member",
  roles: "Role",
  general: "Update",
};

export const formatNotificationTimeLabel = (value) => {
  const date = toDate(value);
  if (!date) return "Now";
  const diffMs = Date.now() - date.getTime();
  const diffMinutes = Math.max(1, Math.floor(diffMs / 60000));
  if (diffMinutes < 60) return `${diffMinutes}m ago`;
  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};

export const classifyNotificationSection = (createdAt) => {
  const date = toDate(createdAt);
  if (!date) return "earlier";
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const dayDiff = Math.floor((today.getTime() - dayStart.getTime()) / 86400000);
  if (dayDiff === 0) return "today";
  if (dayDiff === 1) return "yesterday";
  if (dayDiff <= 7) return "this_week";
  return "earlier";
};

export const matchesNotificationTab = (notification, tabId) => {
  if (tabId === "all") return true;
  return String(notification?.kind || "general") === tabId;
};

export const isNotificationCountEnabled = (notification, userOrPrefs) => {
  const prefs = userOrPrefs?.notification_prefs || userOrPrefs || {};
  const kind = String(notification?.kind || "general");
  const keys = notificationKindToPreferenceKeys[kind] || [];
  if (!keys.length) return true;
  return keys.some((key) => prefs[key] !== false);
};

export const withNotificationUiFields = (rows = []) =>
  rows.map((item) => ({
    ...item,
    time_label: formatNotificationTimeLabel(item.created_at),
    section: classifyNotificationSection(item.created_at),
    kind_label: notificationKindLabel[item.kind] || notificationKindLabel.general,
  }));
